export const filter = {
  number: '',
  begin_date: '',
  supplier_id: '',
  status_id: '',
  sum: '',
  description: '',
};